export default {
    populateNavigation,
};

const allNavItems = {
    dashboard: { name: 'Dashboard', route: '/dashboard', icon: 'system-dashboard' },
    orders: { name: 'Leads', route: '/orders', icon: 'system-leaderboard' },
    jobs: { name: 'Jobs', route: '/jobs', icon: 'system-box-addon' },
    scheduler: { name: 'Scheduler', route: '/scheduler', icon: 'system-calendar' },
    siteInspectionScheduler: {
        name: 'Site inspection',
        route: '/site-inspection-scheduler',
        icon: 'system-site-inspection-calendar',
    },
    routes: { name: 'Routes', route: '/routes', icon: 'system-route' },
    removalist_jobs: { name: 'Jobs', route: '/jobs', icon: 'system-box-addon' },
    finance: {
        name: 'Finance',
        icon: 'system-payment',
        subitems: {
            transactions: { name: 'Transactions', route: '/finance' },
            payouts: { name: 'Payouts', route: '/payouts' },
        },
    },
    tenants: { name: 'Tenants', route: '/tenants', icon: 'system-companies' },
    users: { name: 'Users', route: '/users', icon: 'system-staff' },
    companies: { name: 'Companies', route: '/companies', icon: 'system-companies' },
    interstate: { name: 'Interstate', route: '/interstate', icon: 'system-interstate' },
    depots: { name: 'Depots', route: '/depots', icon: 'system-depot' },
    local: { name: 'Local prices', route: '/local', icon: 'system-local' },
    fleet: { name: 'Transport', route: '/fleet', icon: 'system-truck' },
    staff: { name: 'Team', route: '/staff', icon: 'system-staff' },
    affiliates: {
        name: 'Affiliates',
        icon: 'system-affiliates',
        subitems: {
            partners: { name: 'Partners', route: '/affiliates' },
            leads: { name: 'Leads', route: '/affiliates/leads' },
        },
    },
    providers: { name: 'Providers', route: '/providers', icon: 'system-providers' },
    communications: { name: 'Communications', route: '/communication', icon: 'system-email-outline' },
    forms: { name: 'Forms', route: '/forms', icon: 'system-document' },
    tools: {
        name: 'Tools',
        icon: 'system-tools',
        subitems: {
            historical_quotes: { name: 'Historical quotes', route: '/tools/historical-quotes' },
            other_insurance: { name: 'Covers with other', route: '/tools/other-insurance' },
            development: { name: 'Development', route: '/development' },
        },
    },
    settings: { name: 'Global Settings', route: '/settings/global', icon: 'system-settings' },
    help: { name: 'Help', route: '/help', icon: 'system-support' },
    quotes: { name: 'Quotes', route: '/quotes', icon: 'system-quote' },
};

const centralContextNav = {
    SUPER: ['dashboard', 'tenants', 'communications', 'users', 'settings'],
    ADMIN: ['dashboard'],
    OWNER: ['dashboard'],
    MANAGER: ['dashboard'],
    FINANCE: ['dashboard'],
    SALES: ['dashboard'],
    OPS: ['dashboard'],
    DEVELOPER: ['dashboard'],
};

const tenantContextNav = {
    SUPER: [
        'dashboard',
        'orders',
        'jobs',
        // 'jobs:ancillary',
        'scheduler',
        'siteInspectionScheduler',
        // 'routes',
        'finance:transactions',
        'finance:payouts',
        // 'finance:coupons',
        // 'companies',
        'depots',
        'local',
        'interstate',
        'fleet',
        'communications',
        'staff',
        // 'affiliates:partners',
        // 'affiliates:leads',
        // 'providers',
        'forms',
        // 'tools:historical_quotes',
        // 'tools:other_insurance',
        // 'settings',
        // 'help',
    ],
    OWNER: [
        'dashboard',
        'orders',
        'jobs',
        // 'jobs:ancillary',
        'scheduler',
        'siteInspectionScheduler',
        // 'routes',
        'finance:transactions',
        'finance:payouts',
        // 'finance:coupons',
        // 'companies',
        'depots',
        'local',
        'interstate',
        'fleet',
        'communications',
        'staff',
        'forms',
        // 'affiliates:partners',
        // 'affiliates:leads',
        // 'providers',
        // 'tools:historical_quotes',
        // 'tools:other_insurance',
        // 'settings',
        // 'help',
    ],
    ADMIN: [
        'dashboard',
        'orders',
        'jobs',
        // 'jobs:ancillary',
        'scheduler',
        'siteInspectionScheduler',
        // 'routes',
        'finance:transactions',
        // 'finance:payouts',
        // 'finance:coupons',
        // 'companies',
        'depots',
        'local',
        'interstate',
        'fleet',
        'communications',
        'staff',
        'forms',
        // 'affiliates:partners',
        // 'affiliates:leads',
        // 'providers',
        // 'tools:historical_quotes',
        // 'tools:other_insurance',
        // 'settings',
        // 'help',
    ],
    MANAGER: [
        'dashboard',
        'orders',
        'jobs',
        // 'jobs:ancillary',
        'scheduler',
        'siteInspectionScheduler',
        // 'routes',
        // 'finance:payouts',
        // 'companies',
        'depots',
        'local',
        'interstate',
        'fleet',
        'staff',
        // 'providers',
        'communications',
        'forms',
        // 'tools:historical_quotes',
        // 'settings',
        // 'help',
    ],
    FINANCE: ['dashboard', 'orders', 'jobs', 'finance:transactions', 'finance:payouts', 'settings'],
    SALES: [
        'dashboard',
        'orders',
        'jobs',
        // 'jobs:ancillary',
        // 'companies',
        // 'interstate',
        'scheduler',
        'siteInspectionScheduler',
        // 'depots',
        'local',
        // 'fleet',
        // 'providers',
        // 'tools:historical_quotes',
        // 'settings',
        // 'help',
    ],
    OPS: [
        'dashboard',
        'orders',
        'jobs',
        // 'jobs:ancillary',
        // 'companies',
        // 'interstate',
        'scheduler',
        'siteInspectionScheduler',
        'depots',
        'local',
        'fleet',
        // 'providers',
        // 'tools:historical_quotes',
        // 'settings',
        // 'help',
    ],
    DEVELOPER: ['tools:development'],
};

function populateNavigation(isTenantContext, roles) {
    const navItemsSet = new Set();

    let roleBasedNav = {};

    // console.log('isTenantContext = ', isTenantContext);

    if (isTenantContext) {
        roleBasedNav = tenantContextNav;
    } else {
        roleBasedNav = centralContextNav;
    }

    roles.forEach((role) => {
        if (role == 'DEVELOPER') {
            return;
        }

        const roleNavItems = roleBasedNav[role] || [];
        roleNavItems.forEach((item) => navItemsSet.add(item));
    });

    if (roles.includes('DEVELOPER')) {
        roleBasedNav['DEVELOPER'].forEach((item) => navItemsSet.add(item));
    }

    const navigation = [];

    navItemsSet.forEach((item) => {
        const [key, subKey] = item.split(':');

        if (subKey) {
            let mainNavItem = navigation.find((nav) => nav.name === allNavItems[key].name);

            if (!mainNavItem) {
                mainNavItem = { ...allNavItems[key], subitems: [] };
                navigation.push(mainNavItem);
            }

            if (!mainNavItem.subitems.find((sub) => sub.name === allNavItems[key].subitems[subKey].name)) {
                mainNavItem.subitems.push(allNavItems[key].subitems[subKey]);
            }
        } else {
            if (!navigation.find((nav) => nav.name === allNavItems[key].name)) {
                navigation.push(allNavItems[key]);
            }
        }
    });

    return navigation;
}
